import * as Icons from "lucide-react";
import { Code2 } from "lucide-react";
import Proveedores from "./internos/Proveedores";
import data from "../config/tecnologias.json";
import { useLanguage } from "../context/LanguageContext";
import StructuredData from "./StructuredData";

const lucideIcons = Icons;
const Tecnologias = ({ isDarkMode }) => {
  <StructuredData type="tecnologias" />;
  const { language, translations } = useLanguage();
  const tecnologias = translations[language].tecnologias;
  const generateLogo = (tech) => {
    if (tech.logoType === "gradient") {
      return (
        <div
          className={`w-full h-full bg-gradient-to-br ${tech.logoConfig.gradientFrom} ${tech.logoConfig.gradientTo} rounded flex items-center justify-center`}
        >
          <span className={`text-white font-bold ${tech.logoConfig.textSize}`}>
            {tech.logoConfig.displayName || tech.name}
          </span>
        </div>
      );
    } else if (tech.logoType === "solid") {
      return (
        <div
          className="w-full h-full rounded flex items-center justify-center"
          style={{ backgroundColor: tech.logoConfig.bgColor }}
        >
          <span className={`text-white font-bold ${tech.logoConfig.textSize}`}>
            {tech.logoConfig.displayName || tech.name}
          </span>
        </div>
      );
    } else if (tech.logoType === "svg") {
      return (
        <svg viewBox="0 0 24 24" className="w-full h-full">
          <path fill={tech.logoConfig.fillColor} d={tech.logoConfig.svgPath} />
        </svg>
      );
    } else if (tech.logoType === "solidWithText") {
      return (
        <div
          className="w-full h-full rounded flex items-center justify-center"
          style={{ backgroundColor: tech.logoConfig.bgColor }}
        >
          <span
            className={`font-bold ${
              tech.logoConfig.textColor || "text-white"
            } ${tech.logoConfig.textSize}`}
          >
            {tech.logoConfig.displayName || tech.name}
          </span>
        </div>
      );
    } else if (tech.logoType === "svgDynamic") {
      return (
        <svg viewBox="0 0 24 24" className="w-full h-full">
          <path
            fill={
              isDarkMode
                ? tech.logoConfig.fillColorDark
                : tech.logoConfig.fillColorLight
            }
            d={tech.logoConfig.svgPath}
          />
        </svg>
      );
    } else if (tech.logoType === "iconGradient") {
      const IconComponent = lucideIcons[tech.logoConfig.icon];
      return (
        <div
          className={`w-full h-full bg-gradient-to-br ${tech.logoConfig.gradientFrom} ${tech.logoConfig.gradientTo} rounded flex items-center justify-center`}
        >
          <IconComponent
            className="text-white"
            size={tech.logoConfig.iconSize}
          />
        </div>
      );
    }
  };

  const technologies = data.tecnologias.map((tech) => ({
    ...tech,
    logo: generateLogo(tech),
  }));

  const itemsPerRow = Math.ceil(technologies.length / 3);
  const row1 = technologies.slice(0, itemsPerRow);
  const row2 = technologies.slice(itemsPerRow, itemsPerRow * 2);
  const row3 = technologies.slice(itemsPerRow * 2);

  const row1Duplicated = [...row1, ...row1, ...row1];
  const row2Duplicated = [...row2, ...row2, ...row2];
  const row3Duplicated = [...row3, ...row3, ...row3];

  return (
    <section
      className={`py-20 overflow-hidden ${
        isDarkMode ? "dark:bg-gray-900" : "bg-white"
      }`}
    >
      <div className="container mx-auto px-4 mb-12">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#12A9B0]/10 rounded-full mb-4">
            <Code2 size={20} className="text-[#12A9B0]" />
            <span className="text-sm font-medium text-[#12A9B0]">
              {tecnologias.titulos.stackTecnologico}
            </span>
          </div>

          <h2 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
            {tecnologias.titulos.tecnologiasUtilizamos}
          </h2>

          <p className="text-xl max-w-3xl mx-auto text-gray-600 dark:text-gray-400">
            {tecnologias.textos.descripcion}
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="relative">
          <div className="flex animate-scroll-slow">
            {row1Duplicated.map((tech, index) => (
              <a
                key={`row1-${tech.name}-${index}`}
                href={tech.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 mx-3 p-4 rounded-xl transition-all duration-300 hover:scale-110 group bg-white hover:shadow-xl dark:bg-gray-800 dark:hover:bg-gray-700"
              >
                <div className="flex flex-col items-center gap-2 w-28">
                  <div className="w-14 h-14 flex items-center justify-center">
                    {tech.logo}
                  </div>
                  <span className="text-xs font-medium text-center text-gray-700 dark:text-gray-300">
                    {tech.name}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400">
                    {tech.category}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="flex animate-scroll-reverse-slow">
            {row2Duplicated.map((tech, index) => (
              <a
                key={`row2-${tech.name}-${index}`}
                href={tech.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 mx-3 p-4 rounded-xl transition-all duration-300 hover:scale-110 group bg-white hover:shadow-xl dark:bg-gray-800 dark:hover:bg-gray-700"
              >
                <div className="flex flex-col items-center gap-2 w-28">
                  <div className="w-14 h-14 flex items-center justify-center">
                    {tech.logo}
                  </div>
                  <span className="text-xs font-medium text-center text-gray-700 dark:text-gray-300">
                    {tech.name}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400">
                    {tech.category}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="flex animate-scroll-slower">
            {row3Duplicated.map((tech, index) => (
              <a
                key={`row3-${tech.name}-${index}`}
                href={tech.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 mx-3 p-4 rounded-xl transition-all duration-300 hover:scale-110 group bg-white hover:shadow-xl dark:bg-gray-800 dark:hover:bg-gray-700"
              >
                <div className="flex flex-col items-center gap-2 w-28">
                  <div className="w-14 h-14 flex items-center justify-center">
                    {tech.logo}
                  </div>
                  <span className="text-xs font-medium text-center text-gray-700 dark:text-gray-300">
                    {tech.name}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400">
                    {tech.category}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
      <Proveedores isDarkMode={isDarkMode} />
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-20 h-full pointer-events-none bg-gradient-to-r from-gray-50 to-transparent dark:bg-gradient-to-r dark:from-gray-900 dark:to-transparent"></div>
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-20 h-full pointer-events-none bg-gradient-to-l from-gray-50 to-transparent dark:bg-gradient-to-l dark:from-gray-900 dark:to-transparent"></div>
    </section>
  );
};

export default Tecnologias;
